import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import XHR from 'i18next-xhr-backend';
import languageEN from './consts/locales/en/translation/en';
 import languageES from './consts/locales/en/translation/es.json';
 import languageJA from './consts/locales/en/translation/ja.json';
 import languagePA from './consts/locales/en/translation/pa.json';


i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
        en: languageEN,
        es: languageES,
        ja: languageJA,
        pa: languagePA
    },
    /* default language when load the website in browser */
    //lng: "ja",
    /* When react i18next not finding any language to as default in borwser */
    fallbackLng: "en",
    /* debugger For Development environment */
    debug: true,
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: ".",
    interpolation: {
        escapeValue: false,
        formatSeparator: ","
    },
    react: {
        wait: true,
        bindI18n: 'languageChanged loaded',
        bindStore: 'added removed',
        nsMode: 'default',
        useSuspense: false
    }
});


export default i18n;